import Task from '../schema/Task';

const TEAM_SOURCE_PREFIX = 'com.microsoft.teams.message';

export function hasTeamsSource(task: Task): boolean {
    return task.Source
        ? task.Source.substring(0, TEAM_SOURCE_PREFIX.length) === TEAM_SOURCE_PREFIX
        : false;
}
